import "./Information.module.css";
import Header from "@/reusable_sections/Header";
import BlogList from "./sections/BlogList";
import Footer from "@/reusable_sections/Footer";
export default function InformationPage() {
  return <div>
      <Header />
      <BlogList />
      <Footer />
    </div>;
}